import Data from "~/util/data";

export class Goals extends Data {
    public constructor(
        public goal_1: string | null = null,
        public goal_2: string | null = null,
        public goal_3: string | null = null,
    ) {
        super();
    }
}
